import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
    providedIn: 'root'
})
export class BranchMenuService {

    constructor(public db: AngularFirestore) {}

    create(value){
      return this.db.collection('branchMenu').add(value);
    }

    getByKey(key){
      return this.db.collection('branchMenu').doc(key).get();
    }

    set(key, value){
      return this.db.collection('branchMenu').doc(key).set(value);
    }

    update(key, value){
      return this.db.collection('branchMenu').doc(key).update(value);
    }

    delete(key){
      return this.db.collection('branchMenu').doc(key).delete();
    }

    get(){
      return this.db.collection('branchMenu').get();
    }

    getByBranch(value){
      return this.db.collection('branchMenu',ref => ref.where('branchId', '==', value)).get();
    }

}
